import {
    getUsageEvent,
    listUsageEvents,
} from './queries';

import {GraphQLQuery} from '@aws-amplify/api';
import {UsageEvent} from "../types.ts";
import {billingApiClient} from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";

export type ListUsageEvents = {
    listUsageEvents: { items: UsageEvent[], nextToken: string }
}

export type GetUsageEvent = {
    getUsageEvent: UsageEvent
}

const client = billingApiClient;

const normalizeFilter = (filter: { [key: string]: string }) =>
    Object.keys(filter).reduce((acc: { [key: string]: string }, key) => {
        if (filter[key] !== '' && filter[key] !== undefined) {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

// FNP-536: read-only module. No create/update/delete — the ingestion writer (FNP-215,
// IAM-only) owns the lifecycle. listUsageEvents is the single admin browse query
// (record-type-created-index, newest-first). The supported UsageEventsFilterInput fields
// are { accountId, customerId, meterCode, unresolvedCustomer, unmetered }; fetchRecords
// forwards whatever subset is active. Nothing is faked client-side.
//
// PAGE UNDER-FILL (FNP-594): the filters are non-key FilterExpressions, so DynamoDB can
// return a near-empty page with a non-null nextToken — the hook MUST keep paging until
// nextToken is null, never stop on an empty page (the useInfiniteQuery loop carries this).
export const fetchRecords = async (query: ListRecordsQuery) => {
    const {filter, limit, nextToken} = query;
    const normalized = filter ? normalizeFilter(filter as { [key: string]: string }) : {};

    const response = await client.graphql<GraphQLQuery<ListUsageEvents>>({
        query: listUsageEvents,
        variables: {
            ...(Object.keys(normalized).length ? {filter: normalized} : {}),
            ...(query.sort ? {sort: query.sort} : {}),
            limit,
            nextToken,
        },
    });
    return {
        // FNP-539 backstop: guard a GraphQL-level error (response.data undefined) so the
        // hook always receives a real array, never an undefined item.
        items: response.data?.listUsageEvents.items ?? [],
        nextToken: response.data?.listUsageEvents.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetUsageEvent>>({
        query: getUsageEvent,
        variables: {id: id},
    });
    return response.data?.getUsageEvent;
};
